﻿import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basiscs/tk.manager';
import TKHeader from '@tk/components/tk.header';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKViewport from '@tk/basiscs/tk.viewport';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKFormZipCity from '@tk/controls/tk.form.zipcity';
import TKMinibasket from '@tk/components/tk.minibasket';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKCompareListLink from '@tk/components/tk.compare.list.link';
import TKDialog from '@tk/components/tk.dialog';
import TKButtonDropdown from '@tk/controls/tk.button.dropdown';
import KWSearch from '@/controls/kw.search';
import KWFileUploadArea from '@/components/kw.file.upload.area';
import KWSessionvar from '@/components/kw.sessionvar';
import KWTourSchedule from '@/components/kw.tour.schedule';
import KWFormElement from '@/components/kw.form.element';
import KWDialog from '@/components/kw.dialog';
import KWTable from '@/components/kw.table';
import KWScan from '@/components/kw.scan';
import KWTabsTab from '@/components/kw.tabs.tab';

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@scss/modules/verification.scss';

export default class Verification extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-search', constructor: KWSearch },
            { name: 'tk-form-zip-city', constructor: TKFormZipCity },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-minibasket', constructor: TKMinibasket },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-list-link', constructor: TKCompareListLink },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-file-upload-area', constructor: KWFileUploadArea },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'kw-sessionvar', constructor: KWSessionvar },
            { name: 'kw-form-element', constructor: KWFormElement },
            { name: 'kw-tour-schedule', constructor: KWTourSchedule },
            { name: 'kw-dialog', constructor: KWDialog },
            { name: 'tk-table', constructor: KWTable },
            { name: 'kw-scan', constructor: KWScan },
            { name: 'tk-tabs-tab', constructor: KWTabsTab },
        ]);
    }
}

// eslint-disable-next-line no-new
new Verification();
